import { render, staticRenderFns } from "./SpecialOfferLabel.vue?vue&type=template&id=d5cae5ac&scoped=true&"
import script from "./SpecialOfferLabel.vue?vue&type=script&lang=js&"
export * from "./SpecialOfferLabel.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOfferLabel.vue?vue&type=style&index=0&id=d5cae5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cae5ac",
  null
  
)

export default component.exports